import {
  GAMES_LIST_SUCCESS,
  GAMES_FILTER_HANDLING,
  GAMES_SEARCH_NAME,
  GAMES_INFO_SUCCESS,
  IP_ADDRESS_INFO,
} from "../actionTypes/games";

const INIT_STATE = {
  gamesList: [],
  isSuccess: false,
  queryInfo: {
    page: 0,
    limit: 10,
  },
  totalRecords: 0,
  page: 0,
  games: [],
  gamesInfo: {},
  ipAddressInfo: {},
};

function GamesReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case IP_ADDRESS_INFO: {
      console.log({ payload });
      return {
        ...state,
        ipAddressInfo: payload,
      };
    }
    case GAMES_INFO_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        gamesInfo: payload.data,
        isInfo: true,
        isEdit: true,
      };
    }
    case GAMES_LIST_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        searchStatus: false,
        gamesList: payload.data,
        queryInfo: {
          ...payload.queryInfo,
        },
        totalRecords: payload.totalRecords,
        isSuccess: false,
      };
    }
    case GAMES_FILTER_HANDLING: {
      console.log({ payload });
      return {
        ...state,
        columnHandling: payload.columnHandling,
        gamesType: payload.gamesType,
      };
    }
    case GAMES_SEARCH_NAME: {
      console.log({ payload });
      return {
        ...state,
        searchName: payload,
        searchStatus: true,
        queryInfo: { page: 0, limit: state.queryInfo.limit },
      };
    }

    default:
      return state;
  }
}

export default GamesReducer;
